import { Link, useLocation } from "react-router-dom";
import { companyLogo } from "../assets";
import { useEffect, useState } from "react";
import { TiThMenuOutline } from "react-icons/ti";
import { IoMdClose } from "react-icons/io";
const nav = [
  { Nav: "PLAYS", linkTo: "/product/spotify-plays" },
  { Nav: "LISTENERS", linkTo: "/product/spotify-monthly-listeners" },
  { Nav: "PLAYLISTS", linkTo: "/product/spotify-playlists-placement" },
  { Nav: "FOLLOWERS", linkTo: "/product/spotify-followers" },
  { Nav: "FREE PROMO", linkTo: "/product/get-free-spotify-Promotion" },
];

const Navbar = () => {
  const [Active, setActive] = useState("");
  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const pagesWithoutHeaderFooter = [
    "/product/spotify-plays/Payment",
    "/product/spotify-monthly-listeners/Payment",
    "/product/playlists-placement/Payment",
    "/product/spotify-followers/Payment",
    "/product/get-free-spotify-Promotion",
    "/orderpayment",
    "/terms-and-conditions",
    "/privacy-policy",
    "/refund-policy",
  ]; // Add "/profile" to exclude header and footer for profile.jsx

  // Check if the current page should have header and footer
  const shouldShowHeaderFooter = !pagesWithoutHeaderFooter.includes(
    location.pathname
  );
  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [toggle]);

  return (
    <nav
      className={` ${
        !shouldShowHeaderFooter ? "relative" : "absolute"
      } w-screen shadow-xl md:shadow-none py-2 z-[1000]`}
    >
      <div className="relative flex items-center justify-between mx-5 md:px-14 md:mr-16 xl:mr-56">
        {/* Logo */}
        <div className="flex-shrink-0 pt-3 md:block flex justify-end md:justify-start w-2/3 md:w-1/2">
          <Link to="/" onClick={() => setActive("")}>
            <img
              src={companyLogo}
              alt="spotiviral logo"
              className="scale-125  w-28 md:w-30 lg:w-30 object-contain lg:mx-14"
            />
          </Link>
        </div>
        <div className="hidden md:flex justify-center w-1/3 md:w-1/2 items-center text-lg lg:text-sm lg:font-semibold gap-6 lg:gap-10 font-bold">
          {nav.map((value) => (
            <Link
              key={value.Nav}
              to={value.linkTo}
              className={` ${
                Active === value.Nav
                  ? "font-bold "
                  : `   ${
                      !shouldShowHeaderFooter ? "text-black " : "text-white"
                    }`
              } hover:font-bold `}
              onClick={() => setActive(value.Nav)}
            >
              {value.Nav}
            </Link>
          ))}
        </div>
        <div className="md:hidden flex flex-1 justify-end items-center w-full">
          <button
            type="button"
            className="text-2xl text-green-700 p-2 -mr-2 touch-manipulation"
            onClick={() => setToggle((v) => !v)}
            aria-expanded={toggle}
            aria-label={toggle ? "Close menu" : "Open menu"}
          >
            {toggle ? <IoMdClose /> : <TiThMenuOutline />}
          </button>
        </div>
      </div>

      {/* Full-screen mobile menu: fixed layer above page content (fixes taps blocked by hero / z-index) */}
      {toggle && (
        <div
          className="fixed inset-0 z-[1001] flex flex-col md:hidden bg-emerald-500/95 backdrop-blur-md"
          role="dialog"
          aria-modal="true"
          aria-label="Site navigation"
        >
          <div className="flex items-center justify-between px-5 pt-3 pb-2">
            <Link
              to="/"
              onClick={() => {
                setToggle(false);
                setActive("");
              }}
            >
              <img
                src={companyLogo}
                alt="spotiviral logo"
                className="scale-125 w-28 object-contain"
              />
            </Link>
            <button
              type="button"
              className="text-3xl text-black p-2 touch-manipulation"
              onClick={() => setToggle(false)}
              aria-label="Close menu"
            >
              <IoMdClose />
            </button>
          </div>
          <div className="flex flex-1 flex-col justify-start items-center gap-8 pt-10 px-6">
            {nav.map((value) => (
              <Link
                key={value.Nav}
                to={value.linkTo}
                className={`text-lg font-bold text-black hover:opacity-80 touch-manipulation py-2 ${
                  Active === value.Nav ? "underline" : ""
                }`}
                onClick={() => {
                  setActive(value.Nav);
                  setToggle(false);
                }}
              >
                {value.Nav}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
